import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfigHelper } from './helpers/config.helper';
import { BrandEnum, ProductTypeEnum } from '../dtos/enum';
import { ShoppingCartDto, UserOrderStatusDto } from '../dtos/dto';
import { RegData } from '../dtos/reg-data';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private brandId: BrandEnum;
  
  constructor(
    private router: Router,
    private configHelper: ConfigHelper,
  ) {
    this.brandId = this.configHelper.getBrandId();
    this.loadGtagScript();
    this.initializeGoogleAnalytics();
  }

  private loadGtagScript() {
    const script = document.createElement('script');
    script.async = true;
    script.id = 'gtag-script';;

    if (this.brandId === BrandEnum.CELPIP) {
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-P23V90ECEE';
      this.initGtag('G-P23V90ECEE');
    } else {
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-R7NCCNH8YM';
      this.initGtag('G-R7NCCNH8YM');
    }

    document.head.appendChild(script);
  }

  private initGtag(trackingId: string) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function (...args: any[]) { (window as any).dataLayer.push(args); };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', trackingId);
  }

  private initializeGoogleAnalytics() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const gtagConfigId = this.getGtagConfigId();
      (window as any).gtag('config', gtagConfigId, {
        'page_path': event.urlAfterRedirects
      });
    });
  }

  private getGtagConfigId(): string {
    return this.brandId === BrandEnum.CELPIP ? 'G-P23V90ECEE' : 'G-R7NCCNH8YM';
  }

  public eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string = null) {
    (window as any).gtag('event', eventName, {
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel
    });
  }

  public orderCompleteEventEmitter(result: UserOrderStatusDto, initialShoppingCart: ShoppingCartDto, reg: RegData){
    try{
      const dataLayer = window['dataLayer'] || [];
      dataLayer.push({
        "event": "Paragon.OrderDone",
        "transactionId": result.userOrderId,
        "transactionTotal": result.total,
        "transactionShipping": result.shippingAndHandling,
        "transactionTax": result.tax,
        "transactionCurrency": result.currencyCode
      });
      initialShoppingCart.shoppingCartItems.forEach(item => {
        if (item.productTypeId === ProductTypeEnum.TestRegistration || item.productTypeId === ProductTypeEnum.RetakeTestRegistration) {
          let location = (reg.testSession.testCentreAddressLine1 || "") +
          (reg.testSession.testCentreAddressLine1 && reg.testSession.testCentreCity ? " " : "") +
          (reg.testSession.testCentreCity || "") +
          " " + reg.testSession.testCentreRegion;
          dataLayer.push({
            "event": "Paragon.RegInOrder",
            "transactionId": result.userOrderId,
            "brandId": this.brandId,
            "ItemName": item.productName,
            "DiscountCode": item.discountCode ? item.discountCode : "",
            "ItemTotalAmount": initialShoppingCart.currencyCode + " "+ item.total,
            "TestPurpose": reg.selectedTestPurposeOption.name,
            "location": location
          });
        }
        else{
          dataLayer.push({
            "event": "Paragon.ProductInOrder",
            "transactionId": result.userOrderId,
            "brandId": this.brandId,
            "ItemName": item.productName,
            "DiscountCode": item.discountCode ? item.discountCode : "",
            "ItemTotalAmount": initialShoppingCart.currencyCode + " "+ item.total,
          });
        }
      });
    }
    catch{
      console.log("Google Analytics tracking failed for order completion");
    }

  }

}
